import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useMemo } from "react";
import { SwiperWithArrows } from "./SwiperWithArrows";
export const SessionSwiper = ({ topSpacing, bottomSpacing, sessions, title, titleUrl, favouritedSessionIds, user, toggleFavourite, noArrows, children }) => {
    const isTablet = useMediaQuery(useTheme().breakpoints.down("sm"));
    const spaceBetween = isTablet ? 15 : 40;
    const items = useMemo(() => {
        if (sessions === null || sessions === void 0 ? void 0 : sessions.length) {
            return sessions.map((session) => ({
                session,
                isLiked: favouritedSessionIds ? favouritedSessionIds === null || favouritedSessionIds === void 0 ? void 0 : favouritedSessionIds.includes(session.id) : null,
                toggleFavourite: user && toggleFavourite ? () => toggleFavourite({ session }) : null
            }));
        }
    }, [sessions, favouritedSessionIds]);
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    return (React.createElement(Box, { paddingTop: topSpacing ? "60px" : 0, paddingBottom: bottomSpacing ? "80px" : 0 },
        React.createElement(SwiperWithArrows, { items: items, spaceBetween: spaceBetween, title: title, titleUrl: titleUrl, noArrows: noArrows }, (item) => children(item))));
};
//# sourceMappingURL=SessionSwiper.js.map